export const getBankLogoUrl = bankCode => {
    let imgUrl;
    switch (bankCode) {
        case 'MBB':
        case 'MAYBANK':
            imgUrl = '/img/banks/Maybank-Simple.png';
            break;
        case 'BUKKU':
            imgUrl = '/img/icons/bukku-128.png';
            break;
        case 'PBB':
        case 'CIMB':
        case 'UOB':
        case 'RHB':
        case 'HLBB':
        case 'UNIVERSAL_RECON':
        default:
            break;
    }
    return imgUrl;
};
